import React, { Fragment, useEffect, useState } from 'react'
import { Button, Table, Modal } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faArrowLeft } from '@fortawesome/free-solid-svg-icons'
import moment from 'moment'

import { statusPagamentosParcelas, status } from '../../../constants/common.constants'
import { formatMoney } from '../../../utils/string.utils'
import CollapsePanel from '../../Common/CollapsePanel'
import OrtodontiaService from '../../../services/ortodontia.service'

export default function VisualizarParcelasOrtodontia({ parcelasPlano, selectedPlano, paciente, firstStep }) {
  const [nomePaciente, setNomePaciente] = useState('')
  const [statusPlano, setStatusPlano] = useState('')
  const [stepIsOpen, setStepIsOpen] = useState('')
  const [showPixModal, setShowPixModal] = useState(false)
  const [pixData, setPixData] = useState(null)

  useEffect(() => {
    if (selectedPlano) {
      const currentStatus = status.find((s) => selectedPlano.statusTratamento === s.value)
      setNomePaciente(selectedPlano.dependente ? selectedPlano.dependente.nome : selectedPlano.paciente.nome)
      setStatusPlano(currentStatus ? currentStatus.label : 'Pendente')
    }
  }, [selectedPlano])

  const toggleIsOpen = (step) => {
    setStepIsOpen(stepIsOpen === step ? '' : step)
  }

  const getStatusParcelaLabel = (parcelaStatus) => {
    const statusObj = Object.values(statusPagamentosParcelas).find((status) => status.value === parcelaStatus)
    return statusObj ? statusObj.label : '--'
  }

  const handleCollapseName = (renegociacao, pagamentosAparelho, suprimentos, aparelhosComplementar, dataCriacao) => {
    const data = dataCriacao ? moment(dataCriacao).format('DD/MM/YYYY') : ''

    if (renegociacao) {
      if (pagamentosAparelho) {
        return `Parcelamento aparelho - renegociado pelo cliente na data ${data}`
      }

      if (aparelhosComplementar) {
        return `Parcelamento aparelho complementar - renegociado pelo cliente na data ${data}`
      }

      if (suprimentos) {
        return `Parcelamento suprimentos - renegociado pelo cliente na data ${data}`
      }

      return `Parcelamento renegociado pelo cliente na data ${data}`
    }

    if (pagamentosAparelho) {
      return 'Parcelamento aparelho'
    }

    if (aparelhosComplementar) {
      return 'Parcelamento aparelho complementar'
    }

    if (suprimentos) {
      return 'Parcelamento suprimentos'
    }

    return 'Parcelamento escolhido no fechamento do contrato'
  }

  const handleGerarPix = async (parcela) => {
    const response = await OrtodontiaService.gerarPix(parcela.id)
    setPixData(response?.data)
    setShowPixModal(true)
  }

  const handleClosePixModal = () => {
    setShowPixModal(false)
    setPixData(null)
  }

  const handleCopyPixKey = () => {
    navigator.clipboard.writeText(pixData?.pixKey)
  }


  return selectedPlano ? (
    <div className='m-3'>
      <h3 className='m-0 text-secondary font-weight-bold'>Plano de Tratamento {selectedPlano.numeroPlano}</h3>
      <div className='mt-4 mb-2 text-secondary'>
        <strong>Paciente:</strong> <span className='text-dark'>{nomePaciente}</span>
      </div>
      <div className='mt-2 mb-4 text-secondary'>
        <strong>Status do Tratamento: </strong>
        <span className='text-dark'>{statusPlano}</span>
      </div>
      {parcelasPlano.map((pagamentoPlano, index) => {
        const {
          parcelas,
          renegociacao,
          dataCriacao,
          pagamentosAparelho,
          suprimentos,
          aparelhosComplementar,
        } = pagamentoPlano
        return (
          <CollapsePanel
            index={index + 'collapse'}
            stepCode={`step${index}`}
            text={handleCollapseName(renegociacao, pagamentosAparelho, suprimentos, aparelhosComplementar, dataCriacao)}
            isOpen={`step${index}` === stepIsOpen}
            toggleIsOpen={toggleIsOpen}
          >
            <div
              className='table-responsive plano-tratamento-detalhe-scroll mt-3'
              style={{ WebkitOverflowScrolling: 'touch' }}
            >
            <Table hover bordered className='mb-0' style={{ minWidth: '880px' }}>
              <thead>
                <tr className='text-center'>
                  <th>Vencimento</th>
                  <th>Parcela</th>
                  <th>Valor</th>
                  <th>Multa</th>
                  <th>Juros</th>
                  <th>Desconto</th>
                  <th>Valor Pago</th>
                  <th>Status</th>
                  <th>Ações</th>
                </tr>
              </thead>
              <tbody>
                {parcelas.map((parcela, index) => {
                  const { valor, colaborador, dataVencimento, juros, multa, valorPago, desconto, status, observacao, numeroParcela, codigoIntegracao, podeGerarPix } = parcela
                  return (
                    <Fragment key={index}>
                      <tr key={index + 'tr1'} className='text-center'>
                        <td>{dataVencimento ? moment(dataVencimento).format('DD/MM/YYYY') : '-'}</td>
                        <td>{numeroParcela}</td>
                        <td>{valor ? formatMoney(valor) : '-'}</td>
                        <td>{multa > 0 ? formatMoney(multa) : '-'}</td>
                        <td>{juros > 0 ? formatMoney(juros) : '-'}</td>
                        <td>{desconto > 0 ? formatMoney(desconto) : '-'}</td>
                        <td>{valorPago > 0 ? formatMoney(valorPago) : '-'}</td>
                        <td>
                          {getStatusParcelaLabel(status)}
                          {observacao && (
                            <>
                              <br />
                              <mark>
                                <small className='text-muted'>{observacao}</small>
                              </mark>
                            </>
                          )}
                        </td>

                        <td>
                          {codigoIntegracao &&
                            <>
                              <a href={`https://asaas.com/i/${codigoIntegracao.replace("pay_", "")}`} target='_blank'>Visualizar</a>
                            </>
                          }

                          {podeGerarPix &&
                            <>
                              <a href='#' onClick={() => handleGerarPix(parcela)}>Gerar Pix</a>
                            </>
                          }
                        </td>
                       
                      </tr>
                    </Fragment>
                  )
                })}
              </tbody>
            </Table>
            </div>
          </CollapsePanel>
        )
      })}
      <div style={backContainerStyle}>
        <div onClick={firstStep}>
          <Button variant='outline-primary' style={backStyle}>
            <FontAwesomeIcon icon={faArrowLeft} />
          </Button>
          <span className='text-primary'>Voltar</span>
        </div>
      </div>

      <Modal show={showPixModal} onHide={handleClosePixModal} centered className='modal-pix'>
          <Modal.Header closeButton>
            <Modal.Title>PIX para Pagamento</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {pixData?.qrCode ? 
            <div className="text-center">
              {pixData?.qrCode && (
                <div className="mb-4">
                  <img src={`data:image/png;base64,${pixData.qrCode}`} alt="QR Code PIX" style={{ maxWidth: '200px' }} />
                </div>
              )}
              {pixData?.pixKey && (
                <div>
                  <p className="mb-2">Chave PIX:</p>
                  <div className="d-flex align-items-center justify-content-center">
                    <code className="bg-light p-2 rounded">{pixData.pixKey}</code>
                    <Button variant="outline-primary" size="sm" className="ml-2" onClick={handleCopyPixKey}>
                      Copiar
                    </Button>
                  </div>
                </div>
              )}
            </div>
            :
            <div className="text-center">
              <p>Não foi possível gerar o PIX para este pagamento, tente novamente ou entre em contato com o suporte.</p>
            </div>
            }
          </Modal.Body>
      </Modal>
    </div>
  ) : (
    <Fragment></Fragment>
  )
}

//////////////////////////////////////////////////////////////////
///////////////////////////// STYLES /////////////////////////////
//////////////////////////////////////////////////////////////////
const backContainerStyle = {
  display: 'flex',
  alignItems: 'center',
  cursor: 'pointer',
  margin: '1.5em 0',
}
const backStyle = {
  borderRadius: '100em',
  fontSize: '1.5em',
  padding: '0 6px',
  marginRight: '10px',
}
